import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  width: calc(50% - 20px);
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: ${(props) => props.additionalInfo && "hidden"};
  overflow: ${(props) => props.jobsSubmittedFor && "hidden"};
  z-index: ${(props) => props.jobsSubmittedFor && "1"};
  height: ${(props) => props.jobsSubmittedFor && "290px"};

  ${mediaMaxWidth.smallDesktop`
    margin: 10px auto;
    width: 650px;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 40px);
  `}

  ${mediaMaxWidth.phone`
    margin: 0 auto;
    height: ${(props) => props.additionalInfo && "235px"};
    margin: ${(props) => props.workInformation && "10px"};
    margin: ${(props) => props.jobsSubmittedFor && "0 10px 10px 10px"};
    width: calc(100vw - 20px);
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.85em;
    padding: 5px;
  `}
`;

export const Body = styled.div`
  display: flex;
  align-items: center;
  height: 300px;
  flex-direction: column;
  padding: 15px 10px 10px 10px;
  -webkit-box-pack: justify;
  justify-content: space-between;
  flex-flow: row wrap;

  justify-content: ${(props) => props.additionalInfo && "flex-start"};
  align-items: ${(props) => props.additionalInfo && "flex-start"};
  height: ${(props) => props.additionalInfo && "200px"};

  align-items: ${(props) => props.jobsSubmittedFor && "flex-start"};
  justify-content: ${(props) => props.jobsSubmittedFor && "flex-start"};
  flex-flow: ${(props) => props.jobsSubmittedFor && "column"};
  height: ${(props) => props.jobsSubmittedFor && "unset"};

  align-items: ${(props) => props.noData && "center"};
  justify-content: ${(props) => props.noData && "center"};

  ${mediaMaxWidth.smallDesktop`
    height: ${(props) => props.additionalInfo && "165px"};
  `}

  ${mediaMaxWidth.phone`
    height: unset;
    height: ${(props) => props.additionalInfo && "175px"};
    font-size: 0.9em;
    padding: 10px 10px 0 10px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.85em;
    padding: 5px 5px 0 5px;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.noAlign ? "flex-start" : "space-evenly"};
  width: calc(50% - 20px);
  height: 75px;

  div {
    padding-top: 0;
  }

  ${mediaMaxWidth.phone`
    width: calc(100% - 20px);
    flex-direction: row;
    height: unset;
    margin: 5px 0;
    justify-content: ${(props) => props.cvField && "center"};
    align-items: ${(props) => props.cvField && "center"};
    height: ${(props) => props.cvField && "50px"};
  `}
`;

export const ColumnTitle = styled.div`
  font-weight: 700;
  display: flex;
  flex: 2;

  ${mediaMaxWidth.phone`
    flex: 1;
  `}
`;

export const ColumnValue = styled.div`
  display: flex;
  flex: 3;
  text-transform: ${(props) => props.capitalize && "capitalize"};

  ${mediaMaxWidth.phone`
    flex: 1;
  `}
`;

export const EditButtonLink = styled.a`
  position: absolute;
  z-index: 1;
  right: 15px;
  top: 8px;
  box-shadow: 0 0 10px #d2d2d2;
  border-radius: 50%;

  ${mediaMaxWidth.phone`
    right: 10px;
  `}
`;

export const ReadMore = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 8px 8px;

  ${mediaMaxWidth.smallDesktop`
    height: 60px;
  `}
`;

export const ReadMoreButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.85em;
  text-transform: capitalize;

  &:hover {
    color: #f2008c;
  }
`;

export const EditButton = styled.div`
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #fff;
  transition: 0.1s ease-in-out;

  svg {
    color: #f2008c;
    transition: 0.1s ease-in-out;
    font-size: 0.87em;
  }

  &:hover {
    background-color: #673490;

    svg {
      color: #fff;
    }
  }
`;
